import React from "react";

const BackArrowCompoentIcon = ({ width = 17, height = 18, fill = "#383838", className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M15.9782 10.1926C15.9086 10.2039 15.8383 10.2091 15.7678 10.2082H3.77466L4.03617 10.3299C4.29179 10.4508 4.52434 10.6155 4.7234 10.8164L8.08659 14.1796C8.52952 14.6024 8.60395 15.2826 8.26296 15.7912C7.86609 16.3332 7.105 16.4509 6.56297 16.054C6.51918 16.0219 6.47756 15.987 6.43844 15.9493L0.35674 9.86764C-0.118546 9.39289 -0.118964 8.62275 0.355789 8.14747C0.356093 8.14717 0.356436 8.14682 0.35674 8.14652L6.43844 2.06481C6.91411 1.59048 7.68424 1.59154 8.15862 2.06721C8.19594 2.10465 8.2308 2.14448 8.26296 2.18645C8.60395 2.69507 8.52952 3.37527 8.08659 3.7981L4.72949 7.16736C4.55103 7.34601 4.34584 7.49581 4.12131 7.61133L3.75641 7.77553H15.7009C16.3222 7.75246 16.8674 8.18651 16.9841 8.79726C17.0917 9.46036 16.6413 10.0851 15.9782 10.1926Z"
        fill={fill}
      />
    </svg>
  );
};

export default BackArrowCompoentIcon;
